import { render, staticRenderFns } from "./ModalTableMultiSelectServer.vue?vue&type=template&id=06ac1e3c&"
import script from "./ModalTableMultiSelectServer.vue?vue&type=script&lang=js&"
export * from "./ModalTableMultiSelectServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports